<template>
  <!--支付成功-->
  <div id="paysuccess">
    <h2 class="title">
      <a @click="back" class="prev"></a>
      付款成功
    </h2>
    <div class="main">
      <img src="../../../../assets/icon/paysuccess_icon_bingo.png" alt="">
      <h4>支付成功</h4>
    </div>
    <div class="bottom">
      <router-link :to="{name: 'MyClass'}">我的课程</router-link>
      <router-link :to="{name: 'MyOrder'}">查看订单</router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PaySuccess',
  methods: {
    back () {
      if (window.history.length <= 1) {
        this.router.push({path: '/'})
      } else {
        this.$router.go(-1)
      }
    }
  }
}
</script>

<style scoped lang="stylus">
#paysuccess
  .title
    position: relative
    height: 1.08rem
    line-height: .8rem
    background-color: transparent
    padding: .14rem .16rem
    font-size: .32rem
    color: #050505
    font-weight: 600
    text-align: center
    -webkit-box-sizing: border-box
    -moz-box-sizing: border-box
    box-sizing: border-box
    a.prev
      position: absolute
      top: .14rem
      left: .16rem
      display: block
      width: .8rem
      height: .8rem
      background-color: #fff
      -webkit-border-radius: 50%
      -moz-border-radius: 50%
      border-radius: 50%
      &::before
        content: ""
        position: absolute
        top: .3rem
        left: .32rem
        display: block
        width: .20rem
        height: .20rem
        border-left: .03rem solid #050505
        border-bottom: .03rem solid #050505
        -webkit-transform: rotate(45deg)
        -moz-transform: rotate(45deg)
        -ms-transform: rotate(45deg)
        -o-transform: rotate(45deg)
        transform: rotate(45deg)
  .main
    text-align: center
    img
      display: block
      width: .96rem
      height: .96rem
      margin: 2.24rem auto 0
    h4
      margin: .4rem 0 0 0
      font-size: .56rem
      color: #333
      text-align: center
  .bottom
    display: flex
    justify-content: space-between
    align-items: center
    width: 5.6rem
    margin: 2rem auto
    a
      display: inline-block
      width: 2.4rem
      height: .72rem
      line-height: .72rem
      border: .02rem solid #FF7052
      background-color: #fff
      font-size: .32rem
      color: #FF7052
      text-align: center
      -webkit-border-radius: .36rem
      -moz-border-radius: .36rem
      border-radius: .36rem
      &:last-child
        background-color: #FF7052
        color: #fff

</style>



// WEBPACK FOOTER //
// src/components/share/popup/order/PaySuccess.vue